var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2ZM7 5.25C6.58579 5.25 6.25 5.58579 6.25 6C6.25 6.41421 6.58579 6.75 7 6.75H17C17.4142 6.75 17.75 6.41421 17.75 6C17.75 5.58579 17.4142 5.25 17 5.25H7ZM12.5366 7.976C12.3955 7.83148 12.202 7.75 12 7.75C11.798 7.75 11.6045 7.83148 11.4634 7.976L7.71342 11.816C7.42402 12.1123 7.42965 12.5872 7.726 12.8766C8.02234 13.166 8.49718 13.1603 8.78658 12.864L11.25 10.3415V18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V10.3415L15.2134 12.864C15.5028 13.1603 15.9777 13.166 16.274 12.8766C16.5704 12.5872 16.576 12.1123 16.2866 11.816L12.5366 7.976Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushUp);
export default __webpack_public_path__ + "static/media/push-up.428a6528cfe48aeaf024530be3ed027e.svg";
export { ForwardRef as ReactComponent };